import { render, staticRenderFns } from "./CarePage.vue?vue&type=template&id=00bed919"
import script from "./CarePage.vue?vue&type=script&lang=js"
export * from "./CarePage.vue?vue&type=script&lang=js"
import style0 from "./CarePage.vue?vue&type=style&index=0&id=00bed919&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports